import React, { memo, useMemo, useState } from "react";
import CardHeader from "./common/CardHeader.jsx";
import Card from "./common/Card.jsx";
import useFetch from "../hooks/useFetch.js";
import { yearMonthDate } from "../helper/index.js";
import withLoadingError from "../helper/HOC/withLoadingError.js";
import HorizontalBarChart from "./common/HorizontalBarChart.jsx";
import FilterComponent from "./common/FilterComponent.jsx";

const Composer = ({ data }) => {
  const config = [
    {
      title: "First Contact",
      info: data.first_contact_online ?? 0,
      icon: "rgba(0, 207, 255, 1)",
    },
    {
      title: "Docs Collected",
      info: data.doc_collection_online ?? 0,
      icon: "rgba(235, 7, 142, 1)",
    },
    {
      title: "Follow-up",
      info: data.follow_up_online ?? 0,
      icon: "rgba(0, 102, 255, 1)",
    },
    {
      title: "Registered",
      info: data.registration_online ?? 0,
      icon: "rgba(234, 168, 110, 1)",
    },
    {
      title: "Meeting Scheduled",
      info: data.meeting_online ?? 0,
      icon: "rgba(54, 43, 115, 1)",
    },
    {
      title: "M0/M1 Completed",
      info: data.checklist_online ?? 0,
      icon: "rgba(139, 177, 0, 1)",
    },
    {
      title: "New Acquisition Online",
      info: data.new_acquisition_online ?? 0,
      icon: "purple",
    },
  ];

  function generateDataList(config) {
    return config.map((element, _i) => {
      const value = element.info;

      return {
        value: value,
        label: element.title,
        color: element.icon,
        id: _i,
      };
    });
  }

  const MemorizedBarChart = memo(HorizontalBarChart, data);
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ width: "100%" }}>
        <MemorizedBarChart data={generateDataList(config)} />
      </div>
    </div>
  );
};

export default function LeadAge() {
  const url = `${process.env.REACT_APP_API_URL}/api/online/v1/avg-lead-age`;
  const [params, setParams] = useState({
    start_time: new Date(),
    end_time: new Date(),
  });

  const processdParams = useMemo(() => {
    const { start_time, end_time } = params;
    return {
      ...params,
      start_time: yearMonthDate(start_time),
      end_time: yearMonthDate(end_time),
    };
  }, [params]);

  const dataState = useFetch(url, processdParams);
  const Overview = withLoadingError(Composer);

  const handleDateChange = (startDate, endDate) => {
    setParams({
      ...params,
      start_time: startDate,
      end_time: endDate,
    });
  };

  const handleParamChange = (id) => (event) => {
    console.log(event);
    setParams({
      ...params,
      [id]: event.target.value,
    });
  };

  const handleResetClick = () => {
    setParams({
      start_time: new Date(),
      end_time: new Date(),
    });
  };

  return (
    <Card>
      <CardHeader text="Average Lead Age" />
      <FilterComponent
        options={{
          date: true,
          leadSource: true,
          leadContact: true,
          reset: true,
        }}
        params={params}
        onParamChange={handleParamChange}
        onDateChange={handleDateChange}
        handleResetClick={handleResetClick}
      />
      <Overview {...dataState} />
    </Card>
  );
}
